export default __webpack_public_path__ + "static/logo-caldofacile-28fb856ed3031358ac0193ab16c4a89b.svg";